import { useMemo } from "react";
import { FileText, History } from "lucide-react";
import { formatDate } from "date-fns";

import { type Conversation } from "shared/apiClient";
import { getText, sentenceCase, type Noticeboard } from "shared/lib";

import { useGetDevelopmentActivityText } from "./hooks";

import { Separator } from "shared/components";

export interface PrintViewHeaderProps {
  conversation: Conversation | undefined | null;
  noticeboardData: Noticeboard | undefined | null;
}

export function PrintViewHeader({
  conversation,
  noticeboardData,
}: PrintViewHeaderProps) {
  const developmentActivityText = useGetDevelopmentActivityText(
    conversation,
    noticeboardData,
  );
  const developmentActivity = useMemo(() => {
    return sentenceCase(developmentActivityText || "");
  }, [developmentActivityText]);

  return (
    <>
      <div className="flex flex-col gap-0.5">
        <h2 className="text-textPrimary text-headinglg">
          {developmentActivity}
        </h2>

        <p className="text-textSubdued text-bodymd">{conversation?.address}</p>
      </div>

      <div className="text-textPrimary flex gap-2">
        <p className="text-bodysm flex items-center gap-1">
          <FileText className="h-4 w-4" />
          {conversation?.identifier?.toUpperCase()}
        </p>

        <Separator orientation="vertical" className="h-auto" />

        <p className="text-bodysm flex items-center gap-1">
          <History className="h-4 w-4" />
          {getText("Planning scheme date of operation")}{" "}
          {conversation?.report_generated_at
            ? formatDate(conversation.report_generated_at, "dd/MM/yyyy")
            : ""}
        </p>
      </div>
    </>
  );
}
